import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';
import Content from '../common/template/content';
import Button from '../common/form/button';
import SPButton from '../common/form/spButton';
import {
  openOsFromMap,
  openOsMateriais,
  openOsInteracoes,
  showCreateFromControlador,
} from '../manutencao/ordem_servico/ordemServicoActions';

const STATUS_LABELS = {
  ABERTA: 'Aberta',
  AGUARDANDO_MATERIAL: 'Aguard. material',
  EM_ATENDIMENTO: 'Em atendimento',
  AGUARDANDO_VALIDACAO: 'Aguard. validação',
  FINALIZADA: 'Finalizada',
  CANCELADA: 'Cancelada',
};

const STATUS_BADGE_CLASS = {
  ABERTA: 'os-badge--blue',
  AGUARDANDO_MATERIAL: 'os-badge--amber',
  EM_ATENDIMENTO: 'os-badge--violet',
  AGUARDANDO_VALIDACAO: 'os-badge--teal',
  FINALIZADA: 'os-badge--green',
  CANCELADA: 'os-badge--gray',
};

const PRIORIDADE_BADGE_CLASS = {
  BAIXA: 'os-badge--gray',
  MEDIA: 'os-badge--blue',
  ALTA: 'os-badge--amber',
  CRITICA: 'os-badge--red',
};

const TIPO_LABELS = {
  CORRETIVA: 'Corretiva',
  PREVENTIVA: 'Preventiva',
  IMPLANTACAO: 'Implantação',
  RECLAMACAO: 'Reclamação',
};

const TIPO_BADGE_CLASS = {
  CORRETIVA: 'os-badge--blue',
  PREVENTIVA: 'os-badge--violet',
  IMPLANTACAO: 'os-badge--teal',
  RECLAMACAO: 'os-badge--amber',
};

const PRIORIDADE_LABELS = {
  BAIXA: 'Baixa',
  MEDIA: 'Média',
  ALTA: 'Alta',
  CRITICA: 'Crítica',
};

const FILTRO_TODOS = '';

function badge(label, modifier) {
  return <span className={`os-badge ${modifier || ''}`}>{label}</span>;
}

function formatarData(valor) {
  if (!valor) return '—';
  return new Date(valor).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function KpiCard({ label, valor, cor, icone }) {
  return (
    <div className="ctrl-hist-kpi-card">
      <div className="ctrl-hist-kpi-icon" style={{ color: cor }}>
        <i className={`fa fa-${icone}`} />
      </div>
      <div className="ctrl-hist-kpi-body">
        <span className="ctrl-hist-kpi-label">{label}</span>
        <strong className="ctrl-hist-kpi-valor" style={{ color: cor }}>
          {valor}
        </strong>
      </div>
    </div>
  );
}

function renderFiltros(filtroStatus, incluirCanceladas, onStatusChange, onCanceladasToggle) {
  return (
    <div className="ctrl-hist-filters-card">
      <div className="os-list-filter-group ctrl-hist-filter-status">
        <label className="os-list-filter-label" htmlFor="ctrl-hist-filtro-status">
          Status
        </label>
        <select
          id="ctrl-hist-filtro-status"
          className="form-control os-list-filter-select"
          value={filtroStatus}
          onChange={onStatusChange}
        >
          <option value={FILTRO_TODOS}>Todos</option>
          {Object.keys(STATUS_LABELS).map(key => (
            <option key={key} value={key}>
              {STATUS_LABELS[key]}
            </option>
          ))}
        </select>
      </div>
      <label className="ctrl-hist-toggle-canceladas">
        <input type="checkbox" checked={incluirCanceladas} onChange={onCanceladasToggle} />
        <span>Exibir canceladas</span>
      </label>
    </div>
  );
}

class ControladorHistoricoManutencaoPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controlador: null,
      resumo: null,
      ordens: [],
      inventario: [],
      inventarioResumo: null,
      loading: false,
      filtroStatus: FILTRO_TODOS,
      incluirCanceladas: false,
    };
    this.carregar = this.carregar.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleCanceladasToggle = this.handleCanceladasToggle.bind(this);
    this.voltar = this.voltar.bind(this);
    this.verOs = this.verOs.bind(this);
    this.novaOs = this.novaOs.bind(this);
    this.abrirMateriais = this.abrirMateriais.bind(this);
    this.abrirInteracoes = this.abrirInteracoes.bind(this);
    this.abrirInventario = this.abrirInventario.bind(this);
  }

  componentDidMount() {
    this.inicializarControlador();
    this.carregar();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.inicializarControlador();
      this.carregar();
    }
  }

  getControladorId() {
    return parseInt(this.props.match.params.id, 10);
  }

  inicializarControlador() {
    const stateControlador = this.props.location.state && this.props.location.state.controlador;
    if (stateControlador && String(stateControlador.id) === String(this.props.match.params.id)) {
      this.setState({ controlador: stateControlador });
    }
  }

  carregar() {
    const controladorId = this.getControladorId();
    if (!controladorId || Number.isNaN(controladorId)) return;

    const { filtroStatus, incluirCanceladas } = this.state;
    const params = {};
    if (filtroStatus) params.status = filtroStatus;
    if (incluirCanceladas) params.incluir_canceladas = '1';

    this.setState({ loading: true });
    const inventarioReq = axiosInstance.get(`/manutencao/controladores/${controladorId}/inventario`, {
      params: { apenas_instalados: '1' },
    });
    const historicoReq = axiosInstance.get(`/manutencao/controladores/${controladorId}/historico_manutencao`, { params });

    Promise.all([historicoReq, inventarioReq])
      .then(([histResp, invResp]) => {
        const data = histResp.data || {};
        const invData = invResp.data || {};
        this.setState(prev => ({
          controlador: data.controlador || prev.controlador,
          resumo: data.resumo || null,
          ordens: data.ordens || [],
          inventario: invData.equipamentos || [],
          inventarioResumo: invData.resumo || null,
          loading: false,
        }));
      })
      .catch(() => {
        toastr.error('Erro', 'Não foi possível carregar o histórico de manutenção.');
        this.setState({ loading: false });
      });
  }

  handleStatusChange(event) {
    this.setState({ filtroStatus: event.target.value }, this.carregar);
  }

  handleCanceladasToggle(event) {
    this.setState({ incluirCanceladas: event.target.checked }, this.carregar);
  }

  voltar() {
    this.props.history.push('/cadcontrolador');
  }

  montarControladorPayload() {
    const { controlador } = this.state;
    const controladorId = this.getControladorId();
    return {
      id: controladorId,
      numero_controlador: (controlador && controlador.numero_controlador) || null,
      grupo_fisico_id: (controlador && controlador.grupo_fisico_id) || null,
      cruzamento: (controlador && controlador.cruzamento) || '',
    };
  }

  verOs(os) {
    this.props
      .openOsFromMap(os.id)
      .then(() => this.props.history.push('/manutencao-os'))
      .catch(() => {});
  }

  novaOs() {
    this.props.showCreateFromControlador(this.montarControladorPayload());
    this.props.history.push('/manutencao-os');
  }

  abrirMateriais(os) {
    this.props
      .openOsMateriais(os.id)
      .then(() => this.props.history.push('/manutencao-os'))
      .catch(() => {});
  }

  abrirInteracoes(os) {
    this.props
      .openOsInteracoes(os.id)
      .then(() => this.props.history.push('/manutencao-os'))
      .catch(() => {});
  }

  abrirInventario() {
    this.props.history.push('/manutencao-inventario');
  }

  renderInventarioSection() {
    const { inventario, inventarioResumo } = this.state;
    const instalados = inventarioResumo ? inventarioResumo.INSTALADO || 0 : inventario.length;

    return (
      <div className="ctrl-hist-inventario-panel">
        <div className="ctrl-hist-inventario-header">
          <div>
            <h5>
              <i className="fa fa-toolbox" /> Inventário instalado
            </h5>
            <p>Patrimônio neste cruzamento — independente do estoque de consumo.</p>
          </div>
          <Button type="button" className="default btn-sm" icon="external-link-alt" label="Gerenciar" onClick={this.abrirInventario} />
        </div>
        {inventario.length === 0 ? (
          <p className="ctrl-hist-inventario-empty">Nenhum equipamento instalado cadastrado para este controlador.</p>
        ) : (
          <div className="ctrl-hist-inventario-grid">
            {inventario.slice(0, 8).map(item => (
              <div key={item.id} className="ctrl-hist-inventario-card">
                <strong>{item.tipo_nome}</strong>
                <span>{item.etiqueta || item.modelo || item.numero_serie || '—'}</span>
                <small>{item.status}</small>
              </div>
            ))}
            {instalados > 8 ? <span className="ctrl-hist-inventario-more">+{instalados - 8} equipamentos</span> : null}
          </div>
        )}
      </div>
    );
  }

  renderTimelineItem(os) {
    return (
      <article className="ctrl-hist-item" key={os.id}>
        <div className="ctrl-hist-item-marker">
          <i className={`fa fa-${os.status === 'FINALIZADA' ? 'check-circle' : 'wrench'}`} />
        </div>
        <div className="ctrl-hist-item-body">
          <div className="ctrl-hist-item-header">
            <div className="ctrl-hist-item-titulo-wrap">
              <strong className="ctrl-hist-item-numero">{os.numero}</strong>
              <span className="ctrl-hist-item-titulo">{os.titulo || 'Sem título'}</span>
            </div>
          </div>

          <div className="ctrl-hist-item-datas">
            <span>
              <i className="fa fa-calendar-plus" />
              <em>Abertura</em> {formatarData(os.data_abertura)}
            </span>
            <span>
              <i className="fa fa-comment-dots" />
              <em>Última interação</em> {formatarData(os.ultima_interacao_data)}
            </span>
          </div>

          <div className="ctrl-hist-item-badges ordem-servico-premium-list">
            {badge(STATUS_LABELS[os.status] || os.status, STATUS_BADGE_CLASS[os.status])}
            {badge(TIPO_LABELS[os.tipo] || os.tipo, TIPO_BADGE_CLASS[os.tipo] || 'os-badge--blue')}
            {os.prioridade
              ? badge(PRIORIDADE_LABELS[os.prioridade] || os.prioridade, PRIORIDADE_BADGE_CLASS[os.prioridade])
              : null}
          </div>

          <div className="ctrl-hist-item-meta">
            {os.equipe_nome ? (
              <span>
                <i className="fa fa-user-friends" /> {os.equipe_nome}
              </span>
            ) : null}
            {os.nome_usuario_responsavel ? (
              <span>
                <i className="fa fa-user" /> {os.nome_usuario_responsavel}
              </span>
            ) : null}
            {os.qtd_materiais > 0 ? (
              <span>
                <i className="fa fa-boxes" /> {os.qtd_materiais} material(is)
              </span>
            ) : null}
            {os.qtd_anexos > 0 ? (
              <span>
                <i className="fa fa-paperclip" /> {os.qtd_anexos} anexo(s)
              </span>
            ) : null}
          </div>

          {os.mensagem_erro ? (
            <p className="ctrl-hist-item-notificacao">
              <i className="fa fa-exclamation-triangle" /> {os.mensagem_erro}
            </p>
          ) : null}

          {os.ultima_interacao_texto ? (
            <p className="ctrl-hist-item-interacao">
              <i className="fa fa-comment-dots" /> {os.ultima_interacao_texto}
              {os.ultima_interacao_usuario ? ` — ${os.ultima_interacao_usuario}` : ''}
            </p>
          ) : null}

          <div className="ctrl-hist-item-actions">
            <button type="button" className="btn btn-primary btn-sm ctrl-hist-ver-os-btn" onClick={() => this.verOs(os)}>
              <i className="fa fa-external-link-alt" /> Ver OS
            </button>
            <div className="os-actions-group">
              <SPButton
                type="button"
                className="default btn-sm"
                icon="comments"
                data-title="Interações"
                onClick={() => this.abrirInteracoes(os)}
              />
              {os.qtd_materiais > 0 ? (
                <SPButton
                  type="button"
                  className="default btn-sm"
                  icon="boxes"
                  data-title="Materiais"
                  onClick={() => this.abrirMateriais(os)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </article>
    );
  }

  render() {
    const { config } = this.props;
    const { controlador, resumo, ordens, loading, filtroStatus, incluirCanceladas } = this.state;

    if (!config || !config.modulo_manutencao) {
      return <Redirect to="/cadcontrolador" />;
    }

    const numero = (controlador && controlador.numero_controlador) || this.getControladorId();
    const grupo = controlador && controlador.grupo_fisico_descricao;

    return (
      <Content>
        <div className="simple-cad-form-premium ctrl-hist-page ordem-servico-premium-list">
          <div className="simple-cad-premium-container">
            <div className="simple-cad-premium-card">
              <div className="simple-cad-premium-header simple-cad-premium-header--actions ctrl-hist-page-header">
                <div>
                  <button type="button" className="ctrl-hist-back-btn" onClick={this.voltar}>
                    <i className="fa fa-arrow-left" /> Voltar aos controladores
                  </button>
                  <h4>
                    <i className="fa fa-history" /> Histórico de manutenção
                  </h4>
                  <p>
                    Controlador <strong>{numero}</strong>
                    {grupo ? ` · ${grupo}` : ''} — timeline de ordens de serviço vinculadas a este equipamento.
                  </p>
                </div>
                <Button type="button" className="primary" icon="plus" label="Nova OS" onClick={this.novaOs} />
              </div>

              <div className="simple-cad-premium-body">
                <div className="ctrl-hist-top-bar">
                  {resumo ? (
                    <>
                      <KpiCard label="Total" valor={resumo.total} cor="#2d3748" icone="clipboard-list" />
                      <KpiCard label="Finalizadas" valor={resumo.finalizadas} cor="#27ae60" icone="check-circle" />
                      <KpiCard label="Em aberto" valor={resumo.em_aberto} cor="#3c8dbc" icone="clock" />
                      <KpiCard label="Canceladas" valor={resumo.canceladas} cor="#94a3b8" icone="ban" />
                    </>
                  ) : (
                    <>
                      <div className="ctrl-hist-kpi-card ctrl-hist-kpi-card--placeholder" />
                      <div className="ctrl-hist-kpi-card ctrl-hist-kpi-card--placeholder" />
                      <div className="ctrl-hist-kpi-card ctrl-hist-kpi-card--placeholder" />
                      <div className="ctrl-hist-kpi-card ctrl-hist-kpi-card--placeholder" />
                    </>
                  )}
                  {renderFiltros(
                    filtroStatus,
                    incluirCanceladas,
                    this.handleStatusChange,
                    this.handleCanceladasToggle,
                  )}
                </div>

                {loading ? (
                  <div className="ctrl-hist-loading">
                    <i className="fa fa-spinner fa-spin" /> Carregando histórico...
                  </div>
                ) : ordens.length === 0 ? (
                  <div className="ctrl-hist-empty">
                    <div className="ctrl-hist-empty-icon">
                      <i className="fa fa-wrench" />
                    </div>
                    <strong>Nenhuma manutenção registrada</strong>
                    <p>Abra uma ordem de serviço para este controlador e ela aparecerá aqui automaticamente.</p>
                    <Button type="button" className="primary" icon="plus" label="Abrir primeira OS" onClick={this.novaOs} />
                  </div>
                ) : (
                  <div className="ctrl-hist-timeline-panel">
                    <div className="ctrl-hist-timeline">{ordens.map(os => this.renderTimelineItem(os))}</div>
                  </div>
                )}

                {this.renderInventarioSection()}
              </div>
            </div>
          </div>
        </div>
      </Content>
    );
  }
}

const mapStateToProps = state => ({
  config: state.auth.config,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ openOsFromMap, openOsMateriais, openOsInteracoes, showCreateFromControlador }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ControladorHistoricoManutencaoPage));
